import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/iphone-mockups/page_1.png'
import _imports_1 from '../assets/iphone-mockups/Page_2.png'
import _imports_2 from '../assets/iphone-mockups/page_3.png'


const _hoisted_1 = {
  id: "features",
  class: "feature-section relative py-8 md:py-16 pb-16 md:pb-20 overflow-hidden bg-gradient-to-b from-[#1E2652] to-[#141B3D]"
}
const _hoisted_2 = { class: "container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" }
const _hoisted_3 = { class: "text-center mb-16 md:mb-24" }
const _hoisted_4 = { class: "iphone-mockups-section mb-32 relative" }
const _hoisted_5 = { class: "flex justify-center relative z-10" }
const _hoisted_6 = { class: "relative w-64 h-80 sm:w-72 sm:h-84 md:w-80 md:h-96 lg:w-96 lg:h-[28rem]" }
const _hoisted_7 = { class: "feature-grid grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_8 = { class: "bg-white/5 backdrop-blur-sm rounded-3xl p-8 h-full transition-all duration-300 hover:bg-white/10 border border-white/10 hover:border-[#B7E000]/30 overflow-hidden relative" }
const _hoisted_9 = { class: "text-2xl font-semibold text-white mb-4" }
const _hoisted_10 = { class: "text-gray-400 mb-6" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "text-gray-300 text-sm" }
const _hoisted_13 = { class: "text-center mt-8 md:mt-12" }

import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CalendarDays, Trophy, Lightbulb, Users, CheckCircle } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureSection',
  setup(__props) {

gsap.registerPlugin(ScrollTrigger)

const titleRef = ref<HTMLElement | null>(null)
const subtitleRef = ref<HTMLElement | null>(null)
const firstMockup = ref<HTMLElement | null>(null)
const secondMockup = ref<HTMLElement | null>(null)
const thirdMockup = ref<HTMLElement | null>(null)

const features = [
  {
    icon: CalendarDays,
    title: 'Réservation',
    description: 'Réservez des terrains auprès de nos clubs partenaires.',
    benefits: ['Disponibilité des terrains en temps réel', "Réservation simple et rapide", "Annulation flexible"]
  },
  {
    icon: Users,
    title: 'Matchmaking',
    description: 'Trouvez des partenaires de jeu ou des adversaires de même niveau autour de vous.',
    benefits: ['Créez ou rejoignez des matchs selon vos critères', 'Matchs amicaux et compétitifs', 'Système de niveaux intégré']
  },
  {
    icon: Lightbulb,
    title: 'Coaching',
    description: 'Réservez des cours avec nos coachs partenaires.',
    benefits: ['Perfectionnez votre niveau et votre style de jeu', 'Cours collectifs et particuliers']
  },
  {
    icon: Trophy,
    title: 'Tournois',
    description: 'Participez à des tournois et des événements organisés par nos clubs partenaires.',
    benefits: ['Systèmes de classements et de communauté', 'Récompenses exclusives pour les vainqueurs']
  }
]

onMounted(() => {
  gsap.from(titleRef.value, {
    y: 50,
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
    scrollTrigger: { trigger: titleRef.value, start: 'top 80%' }
  })

  gsap.from(subtitleRef.value, {
    y: 30,
    opacity: 0,
    duration: 1,
    delay: 0.2,
    ease: 'power3.out',
    scrollTrigger: { trigger: subtitleRef.value, start: 'top 80%' }
  })

  gsap.utils.toArray('.feature-card').forEach((card: any, index: number) => {
    gsap.from(card, {
      y: 50,
      opacity: 0,
      duration: 0.8,
      delay: 0.1 * index,
      ease: 'power3.out',
      scrollTrigger: { trigger: card, start: 'top 85%' }
    })
  })

  // iPhone Mockups scroll animations
  if (secondMockup.value && thirdMockup.value) {
    // First mockup entrance animation
    gsap.from(firstMockup.value, {
      y: 30,
      opacity: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: { 
        trigger: firstMockup.value, 
        start: 'top 85%' 
      }
    })

    // Second mockup appears on scroll from the left
    gsap.to(secondMockup.value, {
      opacity: 1,
      x: '-50%',
      scale: 1,
      rotation: -5,
      duration: 1.5,
      ease: 'power3.out',
      scrollTrigger: { 
        trigger: secondMockup.value, 
        start: 'top 70%',
        toggleActions: 'play none none reverse'
      }
    })

    // Third mockup appears on scroll from the right
    gsap.to(thirdMockup.value, {
      opacity: 1,
      x: '50%',
      scale: 1,
      rotation: 5,
      duration: 1.5,
      delay: 0.2,
      ease: 'power3.out',
      scrollTrigger: { 
        trigger: thirdMockup.value, 
        start: 'top 70%',
        toggleActions: 'play none none reverse'
      }
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", {
          ref_key: "titleRef",
          ref: titleRef,
          class: "text-4xl md:text-6xl font-bold text-white mb-4 leading-tight"
        }, _cache[0] || (_cache[0] = [
          _createTextVNode(" Rejoignez une communauté "),
          _createElementVNode("span", { class: "text-[#B7E000]" }, "active", -1)
        ]), 512)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 -top-20 -bottom-20 flex justify-center items-center pointer-events-none" }, [
          _createElementVNode("div", { class: "w-96 h-96 bg-[#B7E000]/5 rounded-full filter blur-3xl" })
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              ref_key: "firstMockup",
              ref: firstMockup,
              class: "absolute inset-0 z-30 scale-125"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "PadelGo App - Home Screen",
                class: "w-full h-full object-contain drop-shadow-2xl"
              }, null, -1)
            ]), 512),
            _createElementVNode("div", {
              ref_key: "secondMockup",
              ref: secondMockup,
              class: "absolute inset-0 z-20 opacity-0 transform translate-x-8 sm:translate-x-12 md:translate-x-16 scale-95 -rotate-1"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "PadelGo App - Matches Screen",
                class: "w-full h-full object-contain drop-shadow-2xl"
              }, null, -1)
            ]), 512),
            _createElementVNode("div", {
              ref_key: "thirdMockup",
              ref: thirdMockup,
              class: "absolute inset-0 z-10 opacity-0 transform -translate-x-8 sm:-translate-x-12 md:-translate-x-16 scale-95 rotate-1"
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "PadelGo App - Profile Screen",
                class: "w-full h-full object-contain drop-shadow-2xl"
              }, null, -1)
            ]), 512)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature, index) => {
          return _createElementVNode("div", {
            key: index,
            class: "feature-card group"
          }, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(feature.icon), { class: "w-12 h-12 text-[#B7E000] mb-6" })),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(feature.title), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(feature.description), 1),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.benefits, (benefit, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: idx,
                    class: "flex items-start"
                  }, [
                    _createVNode(_unref(CheckCircle), { class: "w-5 h-5 text-[#B7E000] mt-1 mr-2 flex-shrink-0" }),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(benefit), 1)
                  ]))
                }), 128))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#B7E000] to-[#1E2652] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" }, null, -1))
            ])
          ])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", {
          ref_key: "subtitleRef",
          ref: subtitleRef,
          class: "text-xl text-gray-400 max-w-2xl mx-auto"
        }, " Chez PadelGo, notre objectif est de transformer votre expérience de jeu en une expérience unique et enrichissante. ", 512)
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute inset-0 pointer-events-none" }, [
      _createElementVNode("div", { class: "absolute top-1/4 left-0 w-96 h-96 bg-[#B7E000]/10 rounded-full filter blur-3xl" }),
      _createElementVNode("div", { class: "absolute bottom-1/4 right-0 w-96 h-96 bg-[#B7E000]/10 rounded-full filter blur-3xl" })
    ], -1))
  ]))
}
}

})